module.exports = __webpack_public_path__ + "static/media/stormcaller_crown.a5db8285.png";